export enum ProductCategoryAreaNameEnum {
    CITY_MUNI = 'city-muni',
    URBAN = 'urban'
}
